import styled from "styled-components";

interface Props {
  fullText: string;
  highlightedText: string;
}

const Highlight = styled.span`
  font-weight: var(--global-font-weight-bold);
  background-color: var(--green6);
  border-radius: 2px;
  padding: 0 var(--global-spacing-xs);
`;

export const HighlightedText = ({ fullText, highlightedText }: Props) => {
  if (highlightedText === "") return <span>{fullText}</span>;

  const withSpace = highlightedText.replace(/[\s_-]/g, " ");
  const withDash = highlightedText.replace(/[\s_-]/g, "-");
  const withUnderscore = highlightedText.replace(/[\s_-]/g, "_");
  const highlightRegex = new RegExp(
    `${withSpace}|${withDash}|${withUnderscore}`
  );
  return (
    <span>
      {fullText.split(highlightRegex).map((nonMatch, index) => (
        <span key={`${fullText}-fragment-${index}`}>
          {index !== 0 && (
            <Highlight data-testid="highlighted-fragment">
              {withSpace}
            </Highlight>
          )}
          <span>{nonMatch}</span>
        </span>
      ))}
    </span>
  );
};
